import React, { useContext } from "react";
import Logo from "../Logo/Logo";
import AuthContext from "../../context/AuthContext";
import { useTranslation } from "react-i18next";
import LangSwitcher from "../LangSwitch/langSwitcher";
import ImportScript from "../../utils/hooks";

const Header = () => {
  let { user, logoutUser } = useContext(AuthContext);
  const [t, i18n] = useTranslation("common");

  ImportScript(user.username);

  const showSearch = () => {
    document.querySelector(".search-block").classList.toggle("active");
    document.querySelector("body").classList.toggle("apla");
  };

  const showfilters = () => {
    document
      .querySelector(".page-container-filter-bar")
      .classList.toggle("active");
    document.querySelector("body").classList.toggle("apla2");
  };
  function dropdownUserNav() {
    document.querySelector(".dropdown-menu").classList.toggle("active");
  }

  return (
    <div>
      <div className="mobile-filters">
        <button className="trigger-search show-search" onClick={showSearch}>
          <i className="feather icon-search"></i>
        </button>
        <button className="trigger-search" onClick={showfilters}>
          <i className="feather icon-filter"></i>
        </button>
      </div>
      <header className="navbar pcoded-header navbar-expand-lg navbar-light headerpos-fixed">
        <div className="collapse navbar-collapse">
          <div className="head-logo">
            <Logo />
          </div>
          <div>
            <ul className="navbar-nav ml-auto">
              <li>
                <span>
                  <span>
                    {user.roles.map((role) =>
                      role === "ROLE_all-seeing" ? (
                        <span
                          key={role.indexOf()}
                          className="pcoded-badge label label-danger"
                        >
                          ADMIN
                        </span>
                      ) : (
                        ""
                      )
                    )}
                    {user && <>Hello {user.username}!</>}
                  </span>
                </span>
              </li>
              <li>
                <LangSwitcher></LangSwitcher>
              </li>
              <li>
                <div
                  className="dropdown drp-user show"
                  onClick={dropdownUserNav}
                >
                  <a
                    href="#"
                    className="dropdown-toggle"
                    data-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i className="icon feather icon-user"></i>
                  </a>
                  <div className="dropdown-menu dropdown-menu-right profile-notification show">
                    <ul className="pro-body">
                      <li>
                        <button onClick={logoutUser} className="dropdown-item">
                          <i className="feather icon-power text-danger"></i>{" "}
                          Logout
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </header>
    </div>
  );
};

export default Header;
